import { render, staticRenderFns } from "./publicAside.vue?vue&type=template&id=c7de341e&scoped=true&"
import script from "./publicAside.vue?vue&type=script&lang=js&"
export * from "./publicAside.vue?vue&type=script&lang=js&"
import style0 from "./publicAside.vue?vue&type=style&index=0&id=c7de341e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7de341e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VCard,VDivider,VIcon,VListItem,VListItemAvatar,VListItemTitle,VNavigationDrawer})
